module.exports = __webpack_public_path__ + "static/media/freshdesk.8cd954e8.svg";